module.exports = __webpack_public_path__ + "d7fdd3d5.png";